import React, { useState, useEffect } from "react";
//import { Container, Row, Col, Modal, Button, Form, Dropdown, Table } from 'react-bootstrap';
import "./add-affiliates.css";
import DataTable from "react-data-table-component";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../../axios/axios";
import { message } from "antd";
import Modal from "react-bootstrap/Modal";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Button } from "react-bootstrap";
import ReactSelect from "react-select";
import { adminConfig } from "../../../utils/adminConfig";

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
      backgroundColor: "#004aad",
      borderRadius: "10px 10px 0 0",
    },
  },
  footRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
      backgroundColor: "#004aad",
      borderRadius: "10px 10px 0 0",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#fff",
      //backgroundColor: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const UserChangeAffiliate = () => {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [deleteShow, setdeleteShow] = useState(false);

  const [removeAffData, setremoveAffData] = useState({
    id: "",
    affId: "",
    source: "",
  });
  const [viewData, setViewData] = useState([]);
  const [msgShow, setmsgShow] = useState(false);

  const [affiliateData, setaffiliateData] = useState({});
  const [optionUser, setoptionUser] = useState([]);
  const [selected, setSelected] = useState([]);

  const handleCloseDelete = () => setdeleteShow(false);

  const getList = () => {
    setLoading(true);
    axios
      .get(`/get-affiliate-parent/${params.id}`, adminConfig())
      .then((res) => {
        setViewData(res.data.data);
        // setLoading(false);
      })
      .catch((err) => {
        // setLoading(false);
        console.error(err);
      });
  };

  const getAffiliate = () => {
    setLoading(true);
    axios
      .get(`/get-one-affiliate-data/${params.id}`, adminConfig())
      .then((res) => {
        setaffiliateData(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getNoneAffiliate = () => {
    setLoading(true);
    axios
      .get(`/get-none-affilliate-users`, adminConfig())
      .then((res) => {
        let options = [
          {
            label: "Select",
            value: 0,
            isDisabled: true,
          },
        ];

        // eslint-disable-next-line array-callback-return
        res.data.data.map((user, i) => {
          // console.log("certt--", cert);
          let obj = {
            label: `${user.belongsToUser?.name} (${user.belongsToUser?.email}) - ${user.belongsToUser?.source}`,
            value: user.belongsToUser?.id,
          };
          options.push(obj);
        });

        setoptionUser(options);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  useEffect(() => {
    getList();
    getAffiliate();
    getNoneAffiliate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const modalopenForDelete = (id, affId, source) => {
    setremoveAffData({
      id,
      affId,
      source,
    });
    setdeleteShow(true);
  };

  const paidMark = async (id, userId) => {
    setLoading(true);
    await axios
      .get(`/user/commissions-paid/${id}`, adminConfig())
      .then(() => {
        modalopenForDelete(userId);
        setLoading(false);
        message.success("Commission Paid Successfully");
        setmsgShow(true);
        setTimeout(() => {
          setmsgShow(false);
        }, 3000);
      })
      .catch((err) => {
        setLoading(false);
        message.error("Commission Unpaid");
        console.error(err);
      });
  };

  const handleRemoveData = async () => {
    setLoading(true);
    await axios
      .get(
        `/user-affiliate-remove/${removeAffData.id}/${removeAffData.affId}/${removeAffData.source}`,
        adminConfig()
      )
      .then((res) => {
        if (res.data.status) {
          message.success(res.data.message);
        } else {
          message.error(res.data.message);
        }

        setremoveAffData({
          id: "",
          affId: "",
          source: "",
        });
        setdeleteShow(false);
        getList();
        getNoneAffiliate();
        setLoading(false);
      })
      .catch((err) => {
        message.error("Remove Failed!");
        console.error(err);
        setremoveAffData({
          id: "",
          affId: "",
          source: "",
        });
        setdeleteShow(false);
        getList();
        getNoneAffiliate();
        setLoading(false);
      });
  };

  const columns_members = [
    {
      name: "Affiliate Name",
      selector: (row) => row?.name,
      sortable: true,
      width: "300px",
    },
    {
      name: "Affiliate Email ID",
      selector: (row) => row?.email,
      sortable: true,
      width: "220px",
    },
    {
      name: "Affiliate Phone Number",
      selector: (row) => row?.phone,
      sortable: true,
      width: "220px",
    },
    {
      name: "Affiliate Plan",
      selector: (row) => row?.plan,
      sortable: true,
      width: "250px",
    },
  ];

  const handelSubmitData = async () => {
    if (selected.value) {
      setLoading(true);

      let submitData = {
        userIds: selected.value,
        affId: params.id,
      };

      await axios
        .post(`/user-affiliate-update-change`, submitData, adminConfig())
        .then((res) => {
          getList();
          getNoneAffiliate();
          setLoading(false);
          if (res.data.status) {
            message.success(res.data.message);
          } else {
            message.error(res.data.message);
          }
          setSelected([]);
        })
        .catch((err) => {
          getList();
          getNoneAffiliate();
          setLoading(false);
          console.error(err);
          message.error("User add failed!");
          setSelected([]);
        });
    }
  };

  return (
    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <h2>Affiliate of {affiliateData.belongsToUser?.name}</h2>
                <div className="row">
                  <div className="col-md-6">
                    <p>Select to Change Affiliate</p>
                    <ReactSelect
                      name="set_users"
                      options={optionUser}
                      value={selected}
                      onChange={setSelected}
                      labelledBy={""}
                      title="Select"
                    />
                  </div>
                  <div className="col-md-12">
                    <button
                      type="button"
                      class="add_but submit_buttt mt-3"
                      onClick={handelSubmitData}
                    >
                      Change Affiliate
                    </button>
                  </div>
                </div>
                {/* <div className="input-group w-auto float-right mb-3">
                                    <div className="form-outline">
                                        <input
                                            placeholder="Type name or Affiliate Id"
                                            type="text"
                                            id="form1"
                                            className="form-control"
                                            onChange={(e) => {
                                                setQuery(e.target.value);
                                            }}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-primary search_button"
                                        onClick={() => {
                                            setSearch(query);
                                            setPage(1);
                                        }}
                                    >
                                        Search
                                    </button>
                                </div> */}
                <div className="plan_data mt-5">
                  <DataTable
                    columns={columns_members}
                    data={viewData}
                    pagination
                    striped
                    responsive
                    customStyles={customStyles}
                    subHeaderAlign="right"
                    subHeaderWrap
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={deleteShow} onHide={handleCloseDelete}>
        {/* <Modal.Header closeButton>
        </Modal.Header> */}
        <Modal.Body>
          <h4 className="text-center">Are you sure you want to remove?</h4>
          <div className="yes_no_but d-flex align-items-center justify-content-center">
            <Button
              variant="secondary"
              className="yes_but"
              onClick={handleRemoveData}
            >
              Yes
            </Button>
            <Button
              variant="primary"
              className="no_but"
              onClick={handleCloseDelete}
            >
              No
            </Button>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          
        </Modal.Footer> */}
      </Modal>
    </LoadingOverlay>
  );
};

export default UserChangeAffiliate;
